// extracted by mini-css-extract-plugin
var _1 = "18px";
var _2 = "--tether-available-height";
var _3 = "--tether-available-width";
var _4 = "--tether-offset";
export { _1 as "boundaryPadding", _2 as "propertyAvailableHeight", _3 as "propertyAvailableWidth", _4 as "propertyOffset" }
